// extracted by mini-css-extract-plugin
export var container = "_5o-1";
export var editor = "_5o-2";
export var resizable = "_5o-3";
export var wrapper = "_5o-0";